import { useTranslation } from '../i18n';
import LanguageSwitcher from './LanguageSwitcher';

export default function Header() {
  const { dict } = useTranslation();
  return (
    <header className="page-header sticky-header">
      <div className="page-header-left">
        <img
          className="page-logo"
          id="header-logo"
          src="https://ntq.com.vn/wp-content/themes/ntq_branding/assets/images/NTQ-logo.png"
          alt="NTQ Logo"
          onError={e => {
            (e.currentTarget as HTMLImageElement).style.display = 'none';
            const fb = document.getElementById('logo-fallback');
            if (fb) fb.style.display = 'flex';
          }}
        />
        <div id="logo-fallback" className="page-logo-fallback" style={{ display: 'none' }}>NTQ</div>
        <div>
          <div className="page-title">{dict.page_title}</div>
          <div className="page-subtitle">{dict.page_subtitle}</div>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
        <LanguageSwitcher />
        <span className="page-badge">NTQ Solution</span>
      </div>
    </header>
  );
}
